//
// BaseView.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "./moduleBuilder";
import EventDispatcher from "./events/EventDispatcher";
import "./lib";
import "./pickResults/PickResult";
import "./focus/Focusable";
import "./accessibility/AccessibilityController";
import "./resources/images/Image";
import "./selection/SelectionController";
import "./RenderingType";

var BaseView = createModule("commons_BaseView", [10005], EventDispatcher, [
    {
        DISPLAYLISTRENDERER_CHANGED: 20014,
        ACTIVATE: 20015,
        NEEDS_UPDATE_GESTURE_RECOGNIZERS: 20013,
        RENDERING_TYPE_CHANGE: 20016,
        FRAME_VALID: 20011,
        FRAME_INVALID: 20010,
        FRAME_ZERO_SIZE: 20012,
    },
    ,
    ,
    {
        shouldRetainBuffers: 2,
        gestureHandlersEnabled: 2,
        tag: 7,
        accessibilityModeEnabled: 2,
        frame: 12,
    },
    {
        getSubviews: [[1]],
        getSelectionController: [1],
        getPickResultsInAperture: [[1],12,2],
        isWaitingForExternalAssets: [2],
        canHandleGestureDirection: [2,4],
        getNeedsLayout: [2],
        addSubview: [0,1],
        setShouldClearDisplayListBeforeUpdate: [0,2],
        asFocusable: [1],
        getRenderingType: [4],
        getCurrentSelectedPickResults: [[1]],
        rtlTransformXValue: [5,5],
        getAccessibilityController: [1],
        render: [6],
        getImage: [1],
        getNeedsUpdateDisplayList: [2],
        invalidateFrameBufferForDuration: [0,6],
    },
    {
        _create: [4],
        setVisualEffectsEnabled: [0,2],
        getVisualEffectsEnabled: [2],
        visualEffectsEnabled: [2],
    },
    ,
]);
export default BaseView;
